// extracted by mini-css-extract-plugin
export default {"rating":"ww-z","numberOfStars":"xw-z","count":"yw-z","barGraphSpacing":"zw-z","barGraph":"Aw-z"};